// extracted by mini-css-extract-plugin
export default {"wordTable":"WordTable_wordTable__qem2K","word-table":"WordTable_word-table__MWxCf","inputError":"WordTable_inputError__0SOwx"};